<h3 mat-dialog-title>{{ data?.title }}</h3>
<div class="content" mat-dialog-content>
  <p *ngIf="data?.message" [innerHTML]="data?.message"></p>
  <ng-container *ngIf="data.messages">
    <p *ngFor="let message of data.messages" [innerHTML]="message"></p>
  </ng-container>
</div>

<div mat-dialog-actions [ngClass]="data.reverseButtons ? 'button-footer-reverse' : 'button-footer'">
  <button
    autofocus
    goab-button
    [attr.buttonType]="data?.destructiveConfirm ? 'destructive' : 'primary'"
    class="icon-trash"
    [mat-dialog-close]="true"
    [buttonSize]="data.buttonSize ? data.buttonSize : 'normal'"
    data-cy="confirm-yes"
  >
    <span class="button-text">{{ data?.confirmLabel || 'Yes' }}</span>
  </button>
  <button
    goab-button
    buttonType="tertiary"
    [buttonSize]="data.buttonSize ? data.buttonSize : 'normal'"
    data-cy="confirm-no"
    [mat-dialog-close]="false"
  >
    <span class="button-text">{{ data?.cancelLabel || 'No ' }}</span>
  </button>
</div>
